import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-[#1a2332] to-[#2d3e50] text-white mt-12">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Over ons */}
          <div>
            <h3 className="text-[#FDB913] font-bold text-lg mb-4">Over Formule 1 Pool</h3>
            <p className="text-gray-300 text-sm">
              Doe mee met de meest uitdagende Formule 1 voorspellingsgame. Voorspel de race uitslagen,
              kwalificaties en kampioenen, en win geweldige prijzen!
            </p>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-[#FDB913] font-bold text-lg mb-4">Snelle Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/speluitleg" className="text-gray-300 hover:text-[#FDB913] text-sm transition-colors">
                  Speluitleg
                </Link>
              </li>
              <li>
                <Link to="/prijzen" className="text-gray-300 hover:text-[#FDB913] text-sm transition-colors">
                  Prijzen
                </Link>
              </li>
              <li>
                <Link to="/stand" className="text-gray-300 hover:text-[#FDB913] text-sm transition-colors">
                  Klassement
                </Link>
              </li>
              <li>
                <Link to="/kalender" className="text-gray-300 hover:text-[#FDB913] text-sm transition-colors">
                  Racekalender
                </Link>
              </li>
              <li>
                <Link to="/over-ons" className="text-gray-300 hover:text-[#FDB913] text-sm transition-colors">
                  Over Ons
                </Link>
              </li>
              <li>
                <Link to="/privacybeleid" className="text-gray-300 hover:text-[#FDB913] text-sm transition-colors">
                  Privacybeleid
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact & Social */}
          <div>
            <h3 className="text-[#FDB913] font-bold text-lg mb-4">Volg Ons</h3>
            <div className="flex space-x-4 mb-4">
              <a href="#" className="text-gray-300 hover:text-[#FDB913] transition-colors">
                <Facebook size={20} />
              </a>
              <a href="#" className="text-gray-300 hover:text-[#FDB913] transition-colors">
                <Twitter size={20} />
              </a>
              <a href="#" className="text-gray-300 hover:text-[#FDB913] transition-colors">
                <Instagram size={20} />
              </a>
              <a href="mailto:info@sportpooltjes.nl" className="text-gray-300 hover:text-[#FDB913] transition-colors">
                <Mail size={20} />
              </a>
            </div>
            <p className="text-gray-400 text-xs">
              Contact: info@sportpooltjes.nl
            </p>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-6 text-center">
          <p className="text-gray-400 text-sm">
            © 2026 Sportpooltjes. Alle rechten voorbehouden. | Bets for fun - Speel verantwoord
          </p>
          <p className="text-gray-500 text-xs mt-2">
            <Link to="/privacybeleid" className="hover:text-[#FDB913] transition-colors">Privacybeleid</Link>
            {' | '}
            <Link to="/over-ons" className="hover:text-[#FDB913] transition-colors">Over Ons</Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
